/**
 * Provides all colors.
 */
export enum Colors {
  alto = '#E0E0E0',
  codGray = '#101010',
  deYork = '#71CE88',
  eden = '#126556',
  emerald = '#46D281',
  gallery = '#EBEBEB',
  gainsboro = '#DEDEDE',
  geyser = '#c5d2d9',
  gray = '#929292',
  jade = '#00BC6A',
  jungleGreen = '#32B877',
  mystic = '#E3E9ED',
  oceanGreen = '#3EB972',
  mineShaft = '#302D2E',
  mountainMeadow = '#10be6c',
  salem = '#0E9C5F',
  scorpion = '#575757',
  silver = '#C8C8C8',
  silverChalice = '#ACACAC',
  slateGray = '#738a94',
  thunder = '#231F20',
  transparent = 'transparent',
  tundora = '#464646',
  white = '#FFFFFF',
  wildSand = '#F4F4F4',
  mercury = '#E9E9E9',
  shamrock = '#3EC979',
  shamrockDark = '#32C577',
  transparentWhite = 'rgba(255,255,255,0.4)',
  shakespeare = '#48C1D6',
  loulou = '#4A0F3D',
  mauve = '#FCCAFF',
  cyprus = '#004048',
  aquamarine = '#9CFFC4',
  valhalla = '#231E5B',
  periwinkle = '#C2D5FF',
  dodger = '#558EFF',
  portage = '#9E78EE',
  lavenderMagenta = '#EA7AE8',
  yellowOrange = '#FF9948',
  // App Colors
  alabastar = '#F7F7F7',
  // alto = '#DCDCDC',
  black = '#231F20',
  blue = '#547EED',
  boulder = '#767676',
  bonjour = 'rgba(222, 222, 222, 0.5)',
  cararra = '#ECECEC',
  charcoal = '#555555',
  coral = '#FF8941',
  cordGray = '#7F7F7F1A',
  darkGreen = '#00C47B',
  darkGrey = '#929292',
  doveGrey = '#737373',
  dustyGrey = '#999999',
  eclipse = '#393637',
  // emerald = '#39BD71',
  whiteSmoke = '#EEEEEE',
  green = '#46D281',
  grey = '#E8E8E8',
  iron = '#DDDDDD',
  lightGrey = '#EAEAEA',
  mediumGrey = '#D5D6D7',
  mercury = '#E7E7E7',
  mineShaft = '#222020',
  nobel = '#B4B4B4',
  orange = '#FF6D26',
  pink = '#D263C0',
  pureBlack = '#000',
  red = '#FF4A60',
  // salem = '#0E9C5F',
  siam = '#626262',
  // silverChalice = '#A9A9A9',
  // silver = '#C2C1C1',
  snow = '#F7F7F7',
  suvaGray = '#838182',
  stack = '#929292',
  steel = '#D2D2D2',
  martinique = '#393939',
  // thunder = 'rgba(35, 31, 32, 0.52)',
  // transparent = 'transparent',
  // white = '#FFF',
  woodSmoke = '#111117',

  // Transparent black colors
  celeste = 'rgba(0,0,0,0.2)',
  dust = 'rgba(0,0,0,0.4)',
  friar = 'rgba(0,0,0,0.5)',
  mischka = 'rgba(0,0,0,0.1)',
  // tundora = 'rgba(0,0,0,0.7)',
  tuatara = 'rgba(0,0,0,0.85)',
  // Transparent white colors
  breeze = 'rgba(255, 255, 255, 0.3)',
  whisper = 'rgba(255, 255, 255, 0.2)',
  zumthor = 'rgba(255, 255, 255, 0.7)',
  whiteWhisp = 'rgba(238, 238, 238, 0.5)',
  blueGreenWhisper = 'rgba(18, 101, 86, 0.3)',
  ghostWhite = '#f3f3f4',
  liver = '#454344',
  elfGreen = '#008A60',
  dustyGreen = '#3DBF79',
  grey600 = '#5c5c5c',
}
